<template>
  <div class="error">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="error-container">
            <div class="error__code">
              {{ $t('pages.error.404.code') }}
            </div>
            <div class="error__headline">
              {{ $t('pages.error.404.title') }}
            </div>
            <div class="error__copy">
              {{ $t('pages.error.404.copy')}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
}
</script>

<style scoped lang="scss">
.error {
  min-height: 100vh;
  background-color: rgba(155, 155, 155, 0.1);
}

.error-container {
  max-width: 480px;
  text-align: center;
  margin: 0 auto;
}

.error__code {
  @include font('gotham_mediumregular');
  @include font-format(8.063rem, 8.438rem);

  margin: 50px 0 0;

  @include media-breakpoint-up(md) {
    @include font-format(14.063rem, 13.438rem);

    margin: 150px 0 0;
  }
}

.error__headline {
  @include font('gotham_mediumregular');
  @include font-format(1.375rem, 1.625rem);

  margin: 20px 0 10px 0;
}
</style>
